import * as React from 'react';
import { withServerData } from 'hops';

const withLoginState = (Component) => {
  return withServerData(({ serverData: { loginState }, ...props }) => (
    <Component {...props} loginState={loginState} />
  ));
};

export default withLoginState;
